<div class="contract-admins-tab" data-testid="contract-admins-tab">
    @if (!isActive) {
        <div class="alert alert-info" role="status" data-testid="contract-admins-inactive">
            This contract is {{ contract?.deletedAt ? 'deleted' : 'deactivated' }}. Contract admins cannot be viewed or changed.
        </div>
    } @else if (loading) {
        <spinner></spinner>
    } @else {
        @if (loadError) {
            <div class="alert alert-warning" role="alert" data-testid="contract-admins-error">{{ loadError }}</div>
        } @else if (admins.length === 0) {
            <p class="text-muted" data-testid="contract-admins-empty">No contract admins linked</p>
        } @else {
            <div class="table-responsive">
                <table class="table table-sm align-middle" data-testid="contract-admins-table">
                    <caption class="visually-hidden">Contract admins linked to this contract</caption>
                    <thead>
                        <tr>
                            <th scope="col">First name</th>
                            <th scope="col">Last name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Added on</th>
                            <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (admin of admins; track admin.id) {
                            <tr data-testid="contract-admin-row">
                                <td>{{ admin.firstName }}</td>
                                <td>{{ admin.lastName }}</td>
                                <td>{{ admin.email }}</td>
                                <td>{{ admin.addedOn | date: 'dd/MM/yyyy HH:mm' }}</td>
                                <td>
                                    <button type="button" class="btn btn-link link-danger p-0 align-baseline"
                                            [attr.aria-label]="'Unlink ' + adminName(admin)"
                                            [disabled]="removing"
                                            confirmHeader="Confirm the action"
                                            confirmModal="Are you sure you want to unlink the selected admin from this contract?"
                                            confirmMessage=""
                                            confirmOk="Yes, proceed"
                                            confirmCancel="No, cancel"
                                            confirmOkClass="btn-outline-danger"
                                            confirmCancelClass="btn-gray text-dark"
                                            [confirmCancelFirst]="true"
                                            (confirmedClick)="unlink(admin)"
                                            data-testid="contract-admin-unlink">
                                        Unlink
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
        <div class="contract-admins-actions">
            <button type="button" class="btn btn-success" #linkButton
                    [disabled]="removing"
                    (click)="openLinkModal()"
                    data-testid="contract-admins-link">
                <i class="bi bi-link-45deg me-2" aria-hidden="true"></i>Link contract admins
            </button>
        </div>
    }
</div>
